import { render, staticRenderFns } from "./ManagerSupportContent.vue?vue&type=template&id=604dcf09"
import script from "./ManagerSupportContent.vue?vue&type=script&lang=js"
export * from "./ManagerSupportContent.vue?vue&type=script&lang=js"
import style0 from "./ManagerSupportContent.vue?vue&type=style&index=0&id=604dcf09&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports